import { render } from "./MoveCreate.vue?vue&type=template&id=5e12ef6f&scoped=true"
import script from "./MoveCreate.vue?vue&type=script&lang=js"
export * from "./MoveCreate.vue?vue&type=script&lang=js"

import "./MoveCreate.vue?vue&type=style&index=0&id=5e12ef6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e12ef6f"]])

export default __exports__